<template>
    <div class="landing-sidebar">

        <header>
                <SvgIcon class="logo2" name="AnchorLogo"/>

                <p>Welcome to your Anchor portal, where you can manage all aspects of your creator storefront program.</p>
        </header>
        
        <svg viewBox="0 0 42 80" class="logo1">
            <path d="M12.2558 63C9.07901 63 6.39514 62.0321 4.20422 60.0964C2.06807 58.1606 1 55.3743 1 51.7374C1 48.9804 2.31455 46.4581 4.94365 44.1704C7.57276 41.824 11.7081 40.0642 17.3497 38.8911C18.2261 38.7151 19.212 38.5391 20.3075 38.3631C21.4029 38.1285 22.5532 37.8939 23.7582 37.6592V30.7081C23.7582 26.7193 23.2926 23.933 22.3615 22.3492C21.4851 20.7067 20.0884 19.8855 18.1713 19.8855C16.8568 19.8855 15.8161 20.3547 15.0493 21.2933C14.2824 22.1732 13.7895 23.7277 13.5704 25.9567L13.4061 26.9246C13.2965 29.4469 12.7214 31.2947 11.6807 32.4679C10.64 33.6411 9.35288 34.2277 7.81924 34.2277C6.39514 34.2277 5.21752 33.7584 4.28638 32.8198C3.35524 31.8813 2.88967 30.6201 2.88967 29.0363C2.88967 26.6313 3.65649 24.6075 5.19013 22.9651C6.77855 21.3226 8.85992 20.0908 11.4343 19.2696C14.0086 18.4483 16.802 18.0377 19.8145 18.0377C24.6893 18.0377 28.4413 19.3282 31.0704 21.9092C33.7542 24.4316 35.0962 28.567 35.0962 34.3156V53.7612C35.0962 56.4008 36.2464 57.7207 38.5469 57.7207H40.3544L41.0938 58.4246C40.0531 59.8324 38.9029 60.9176 37.6431 61.6802C36.4381 62.4427 34.7128 62.824 32.4671 62.824C30.0571 62.824 28.14 62.2374 26.7159 61.0643C25.3466 59.8324 24.4428 58.2193 24.0047 56.2249C22.3615 58.102 20.6635 59.7151 18.9108 61.0643C17.2128 62.3548 14.9945 63 12.2558 63ZM17.2676 57.6327C18.363 57.6327 19.3763 57.3687 20.3075 56.8408C21.2934 56.2542 22.4436 55.3743 23.7582 54.2011V39.419C23.2104 39.5363 22.6627 39.6536 22.115 39.7709C21.5673 39.8883 20.9374 40.0056 20.2253 40.1229C17.7058 40.8268 15.6792 42.0293 14.1455 43.7304C12.6666 45.3729 11.9272 47.602 11.9272 50.4176C11.9272 52.8226 12.4476 54.6411 13.4882 55.8729C14.5289 57.0461 15.7887 57.6327 17.2676 57.6327Z" fill="white" />
        </svg>

        <nav class="menus" v-if="store.state.user_data">
            <ul>
                <li>
                    <router-link to="/landing" v-tippy="{ content: is_fold ? 'Homepage' : '', placement: 'right' }">
                        <svg-icon name="home" />
                        <span v-if="!is_fold">Homepage</span>
                    </router-link>
                </li>
                <li v-if="(store.state.user_data.is_motom_internal_user && $ProjectName === 'motom') || canSeeCreatorAcademyInCj">
                    <router-link :to="$ProjectName === 'cj' ? '/creator-academy' : '/creator-hq'" v-tippy="{ content: is_fold ? ($ProjectName === 'cj' ? 'Creator Academy' : 'Creator HQ') : '', placement: 'right' }">
                        <svg-icon name="acadmy" />
                        <span v-if="!is_fold">{{ $ProjectName === 'cj' ? 'Creator Academy' : 'Creator HQ' }}</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>

</template>

<script setup>
import SvgIcon from '@/components/ui/SvgIcon.vue';
import { useStore } from 'vuex';
import { getCurrentInstance,computed } from 'vue';

const props = defineProps({
  is_fold: {
    type: Boolean,
    default: false,
  },
})

const store = useStore();
const app = getCurrentInstance().appContext.config.globalProperties;
const { $ProjectName } = app;

const canSeeCreatorAcademyInCj = computed(() => {
    return $ProjectName === 'cj' && (store.state.user_data?.permission_list?.role_type >= 80 || store.state.user_data?.is_motom_internal_user );
});
</script>

<style lang="scss">

.is-fold .landing-sidebar .menus {
    width: 80px;
}
.landing-sidebar {
    // max-width: 360px;
    // min-width: 320px;
    // width: 25%;
    background-color: var(--dark-blue);
    color: white;
    position: relative;

    header {
        display: grid;
        grid-template-rows: 1fr auto;
        grid-template-columns: 100%;
        position: relative;
        padding: 16px 32px 0;
        opacity: 1;
        transition: all ease 0.3s;

        a {
            display: block;
            color: white;

            &:hover {
                color: white;
            }
        }

        .logo2 {
            display: black;
            width: 100%;
        }


        p {
            font-size: 16px;
            min-width: 217px;
        }
    }

    

    .logo1 {
        position: absolute;
        height: 58px;
        width: 58px;
        left: 10px;
        top: 48px;
        opacity: 0;
        transition: all ease 0.3s;
        pointer-events: none;
    }
}

.is-folding {
    .landing-sidebar {
        header {
            opacity: 0;
            pointer-events: none;
        }
    }
}

.is-fold {
    .landing-sidebar {


        header {
            opacity: 0;
            pointer-events: none;
        }

        .logo1 {
            opacity: 1;
            pointer-events: auto;
        }
    }
}
</style>

